
import TicketsFinder from "../ticketsFinder";
import { Loading } from "../layout/loading";
import { NoActiveRaffle } from "../home/NoActiveRaffle";
import { RaffleCatalog } from "../home/RaffleCatalog";
import { usePublicRaffle } from "../../store/hooks/usePublicRaffle";
import { useSearchParams } from "react-router-dom";



export const TicketsFinderPage = () => {
    const [searchParams] = useSearchParams();

    const { raffle: activeRaffleFounded, needsSelection, isLoading: isLoadingGetActiveRaffle, isUninitialized } = usePublicRaffle(searchParams.get("raffleId"));

    if (needsSelection) {
      return <RaffleCatalog title="¿En qué rifa quieres buscar tus números?" getHref={(raffle) => `/ticketsFinder?raffleId=${raffle.id}`} />;
    }

    return !isLoadingGetActiveRaffle && !isUninitialized ? (
      <>
        {activeRaffleFounded ? <TicketsFinder isPublic={true} raffleId={activeRaffleFounded.id} limit={activeRaffleFounded.limit} activeRaffleName={activeRaffleFounded.name} /> : <NoActiveRaffle />}
      </>
    ) : <Loading title="Buscando rifas disponibles"></Loading>;
}
